const API_ENDPOINT = 'https://api.qsi.net/analyze';

export const analyzeUrl = async (url, userId, isPrivate, session) => {
  try {
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      },
      body: JSON.stringify({ url, userId, isPrivate }),
    });

    if (!response.ok) {
      console.error('urlAnalysisService: Network response was not ok', response.status, response.statusText);
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data.jobId;
  } catch (error) {
    console.error('urlAnalysisService: Error:', error);
    throw error;
  }
};